export default __webpack_public_path__ + "static/media/infoPanelHighlight.595af5d0.webp";